import { createApp } from 'vue';
import { createRouter, createWebHashHistory } from 'vue-router';
import App from './App.vue';
import HomeScreen from './components/HomeScreen.vue';
import LessonScreen from './components/LessonScreen.vue';
import CookScreen from './components/CookScreen.vue';
import DebriefScreen from './components/DebriefScreen.vue';
import WeekScreen from './components/WeekScreen.vue';
import { watchAuth } from './firebase.js';
import './styles.css';
import './registerServiceWorker';

// Watch the real Firebase session from start-up, before anything renders —
// App.vue holds the whole app back until it has answered.
watchAuth();

const routes = [
  { path: '/', component: HomeScreen },
  { path: '/week', component: WeekScreen },
  { path: '/lesson/:id', component: LessonScreen, props: true },
  { path: '/cook/:id', component: CookScreen, props: true },
  { path: '/debrief/:id', component: DebriefScreen, props: true },
  { path: '/:pathMatch(.*)*', redirect: '/' }
];

const app = createApp(App);
app.use(createRouter({ history: createWebHashHistory(), routes }));
app.mount('#app');
